export const hintText = (errors, name = 'This') =>
  `${name} ${Array.isArray(errors) ? errors.join(' and ') : errors}`

export const labelFromName = name => name.replace(/([A-Z])/g, ' $1')

export const errorsIsAnException = ({ summary }) => String(summary).match('Exception:')

export const errorsIsOnlySummary = errors => {
  const keys = Object.keys(errors)
  return keys.length === 1 && keys[0] === 'summary'
}

export const errorsWithoutSummary = errors => {
  let output = {}

  Object.keys(errors).forEach(key => {
    if (key !== 'summary') {
      output[key] = errors[key]
    }
  })

  return output
}



// WEBPACK FOOTER //
// ./src/ui/forms/form-from-errors/helpers.js